module cr.events {
    class ResultService implements IResultService {
        bibDetails: {};
        bibNumber:Number;
        endpoint:string = "http://localhost:9011/api/";

        static $inject = ['$http','cfg'];

        constructor(private $http,cfg) {
            if (angular.isDefined(cfg.EventApiUrl))
            {
                this.endpoint=cfg.EventApiUrl;
            }
            console.log("result service endpoint: "+this.endpoint);
        }

        videoReferences(videoToken:string):angular.IPromise<any>
        {
            console.log("videoReferences: "+videoToken);
            return this.$http.jsonp(this.endpoint+'Video/VideoReferences?videoAccessToken='+encodeURIComponent(videoToken)+'&callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        videoLink(eventId,videoRef):angular.IPromise<any>
        {
            console.log("get link for "+angular.toJson(videoRef));
            return this.$http.jsonp(this.endpoint+'Video/VideoUrl/'+eventId+'/'+videoRef.Location+'/'+(videoRef.Time-videoRef.Before*1000)+'/'+(videoRef.Time+videoRef.Before*1000)+'?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
            
        }

        getReportList(eventId:string): angular.IPromise<any> {
            return this.$http.jsonp(this.endpoint+'results/report/list/'+eventId+'?callback=JSON_CALLBACK')
                .then((result) => {
                   return result.data;
                });
        }

        eventSearch(eventId:string,search:string,from:number,maxEntries:number): angular.IPromise<any>
        {
            return this.$http.jsonp(this.endpoint+'results/report/event-search/'+eventId+'/'+from+'/'+maxEntries+'?callback=JSON_CALLBACK&srch='+encodeURIComponent(search))
                .then((result) => {
                    return result.data;
                });
        }

        searchReport(eventId:string,reportId:string,search:string,from:number,maxEntries:number): angular.IPromise<cr.entity.DynamicTable>
        {
            return this.$http.jsonp(this.endpoint+'results/report/search/'+eventId+'/'+reportId+'/'+from+'/'+maxEntries+'?callback=JSON_CALLBACK&srch='+encodeURIComponent(search))
                .then((result) => {
                    return result.data;
                });
        }

        overview(eventId:string,groupId:string,mask:string,search:string,from:number,maxEntries:number): angular.IPromise<cr.entity.DynamicTable>
        {
            return this.$http.jsonp(this.endpoint+'results/live/ligne/overview/'+eventId+'?andmask='+mask+'&group='+groupId+'&from='+from+'&max'+maxEntries+'&callback=JSON_CALLBACK&srch='+encodeURIComponent(search))
                .then((result) => {
                    return result.data;
                });
        }
    }
    eventModule.service('ResultService', ResultService);


}
